import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'pps-entity-action',
  template: `
    <a *ngIf="!isPayCategory()" class="action-icon p-1 text-danger" (click)="deleteEntity($event)" href="#"><i class="fas fa-trash-alt fa-lg" title="Delete"></i></a>
  `,
  styles: [
  ]
})
export class EntityActionComponent implements AgRendererComponent {
  params: ICellRendererParams;

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  afterGuiAttached?(params?: import("ag-grid-community").IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  deleteEntity(evt){
    evt.preventDefault();
    this.params.context.componentParent.deleteEntity(this.params.data);
  }

  isPayCategory(): boolean{
    return this.params.context.componentParent.isPayCategory();
  }
}

